import { render, staticRenderFns } from "./share.vue?vue&type=template&id=c6895448&scoped=true&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style0 from "./share.vue?vue&type=style&index=0&lang=css&"
import style1 from "./share.vue?vue&type=style&index=1&id=c6895448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6895448",
  null
  
)

export default component.exports